module.exports = "<iframe width=\"409px\" height=\"230px\" src=\"<%=videoURL%>?rel=0&amp;controls=0&amp;showinfo=0&amp;title=0&amp;byline=0&amp;portrait=0\" frameborder=\"0\" class=\"fluid250_video fluid250_video--desktop fluid250_video--vert-pos-<%=videoPositionV%> fluid250_video--horiz-pos-<%=videoPositionH%>\" style=\"<%=position%>\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/commercial/views/creatives/iframe-video.html
// module id = 661
// module chunks = 0